var _rect, _rect2, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 200,
    viewBox: "0 0 400 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#1a1a2e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 390,
    height: 190,
    fill: "none",
    stroke: "#444",
    strokeWidth: 2,
    strokeDasharray: "8,4"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 85,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fill: "#666",
    textAnchor: "middle"
  }, "MISSING")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 115,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fill: "#666",
    textAnchor: "middle"
  }, "LOGO")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 155,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fill: "#444",
    textAnchor: "middle"
  }, "DEV MODE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderLogo);
export default __webpack_public_path__ + "static/media/placeholder-logo.d9be7792a044843821f90a4cc48cf47f.svg";
export { ForwardRef as ReactComponent };